import axios from 'axios';

export class TrustPositionService {

    getDataPositions(contrato) {
        return axios.get('/appapv/getDataPositions.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                contrato: contrato,
            }
        }).then(res => res.data.payload);
    }
}